<template>
    <div id="data-list-list-view" class="data-list-container">
            <vs-alert color="danger" title="Course Track Not Found" :active.sync="course_not_found">
                <span>Course  record with id: {{ $route.params.Id }} {{$t('NotFound')}}. </span>
                <span>
                    <span></span><router-link :to="{name:'TraineeHome'}" class="text-inherit underline">{{$t('Back')}}</router-link>
                </span>
            </vs-alert>
            <div class="p-5" v-if="!course_not_found||(this.$route.params.ID&&this.courseModel.ID)">
                 <div class="vx-col">
                        <img
                            width="30px"
                            alt=""
                            height="30px"
                            src="@/assets/images/education.png"
                          />
                   <div class="vx-row">
              
                     <div class="vx-col lg:w-1/4 w-full"> <h3>{{courseModel.Name}}</h3>
                     <h3><span>by   </span> <span v-if="courseModel.Provider" style="font-size:30px;color:#3D7299">{{courseModel.Provider.Name}}</span></h3>
                      <div class="vx-row mt-5 " style="padding-left:13px">
                         <h6 style="color:#A8A8A8"> {{$t('InternalCourseCode')}} : </h6>
                           <p >{{courseModel.CourseCode}}</p>
                           </div> 
                      </div>
                     <div class="vx-col lg:w-1/2 w-full"> 
                     <h4 class="mt-5"  style="color:#3D7299;font-style: italic;">{{$t('About')}}</h4>
                     <!-- <read-more more-str="read more" :text="courseModel.ICAOCategory" link="#" less-str="read less" :max-chars="100"></read-more> -->
                      <p class="mt-2 ml-2" style="color:black;font-size:15px" v-html="courseModel.ICAOCategory"></p>
                      </div> 

                   </div>
                   
                   <div class="vx-row">
                     <div class="vx-col lg:w-1/3 w-full">
                        <h4 class="mt-5"  style="color:#3D7299;font-style: italic;">{{$t('Objectives')}}</h4>
                      
 <p class="mt-2 ml-2" style="color:black;font-size:15px" v-html="courseModel.Objectives"></p>
                        <!-- <read-more more-str="read more" :text="courseModel.Objectives" link="#" less-str="read less" :max-chars="100"></read-more> -->
  
                     </div>
                      <div class="vx-col lg:w-1/3 w-full"> 
                      <div class="vx-col ">
                        <h4 class="mt-5"  style="color:#3D7299;font-style: italic;">{{$t('Prerequisite')}}</h4>
                                <p class="mt-2 ml-2" style="color:black;font-size:15px" v-html="courseModel.Prerequisite"></p>
                        </div>  
                        <div class="vx-col ">
                                <h4 class="mt-5"  style="color:#3D7299;font-style: italic;">{{$t('CourseContent')}}</h4>
                                <div  class="ml-2" v-for="item in courseModel.CourseModules" :key="item.ID">
                                    <div class="mt-2" style="color:black;font-size:15px">{{item.Name}}</div>
                                </div>  
                            </div>                                
                                                           
                     </div>
                        <div class="vx-col  lg:w-1/3 w-full" style="margin-top:50px;font-style: italic;">
                          <div style="margin:3%;"><vs-button color="#3D7299" class="mr-5"  :to="{ path: '/RequestCourseClass' }">{{$t('RequestAtYourLocaion')}}</vs-button></div> 
                        <div style="margin:3%"><vs-button color="#579ACB" class="mr-5"  :to="{ path: '/Report/CourseDetail/'+courseModel.ID }">{{$t('CoursePDF')}}</vs-button>
                           </div>  
                            <div style="margin:3%"><vs-button  color="#FFFFFF" :to="{ path:$acl.check('trainee')? '/TraineeHome' :'/CustomerHome'}"> <span style="color:#3D7299">{{$t('Close')}} X</span> </vs-button>
                           </div>
                    </div>
                   </div>

                   <div class="vx-row">
                     <div class="vx-col lg:w-1/2 w-full">
                       <h4 class="mt-5"  style="color:#3D7299;font-style: italic;">{{$t('References')}}</h4>
                     <!-- <read-more more-str="read more" :text="courseModel.References" link="#" less-str="read less" :max-chars="100"></read-more> -->

                                <p class="mt-2 ml-2" style="color:black;font-size:15px" v-html="courseModel.References"></p>

                     </div>
                     <div class="vx-col lg:w-1/2 w-full">
                       <h4 class="mt-5"  style="color:#3D7299;font-style: italic;">{{$t('PopulationList')}}</h4>
                                <div  class="ml-2" v-for="item in courseModel.CoursePopulationList" :key="item.ID">
                                    <div class="mt-2" style="color:black;font-size:15px">{{item.PopulationList.Name}}</div>
                                </div>
                     </div>
                   </div>

                   <div class="vx-row" style="margin-top:3%">
                     <vx-card style="background-color:#EBF7FF" v-for="tr in courseModel.AnnualPlans" :key="tr.ID" class="mt-5">
                         <div  class="vx-row">
                           <div style="margin:5px;" class="vx-row lg:w-2/3 w-full">
                             <div class="vx-col lg:w-1/4 w-full">
                               <p style="color:#A8A8A8">{{$t('Location')}}</p>
                               <h5 >{{ tr.Location}}</h5>
                             </div>
                             <div class="vx-col lg:w-1/4 w-full">
                               <p style="color:#A8A8A8">{{$t('CourseType')}}</p>
                               <h5  v-if="tr.CourseType!=undefiend">{{ tr.CourseType.Name}}</h5>
                             </div>
                             <div class="vx-col lg:w-1/4 w-full">
                               <p style="color:#A8A8A8">{{$t('Price')}}</p>
                               <h5 >{{ tr.CourseFeeChargedToParticipant +' USD'}}</h5>
                             </div>
                              <div class="vx-col lg:w-1/4 w-full">
                               <p style="color:#A8A8A8">{{$t('Language')}}</p>
                               <h5  v-if="tr.Language">{{ tr.Language.Name }}</h5>
                             </div>
                                <div class="vx-col lg:w-1/4 w-full">
                               <p style="color:#A8A8A8">{{$t('StartDate')}}</p>
                               <h5  >{{ tr.StartDate.split('T')[0] }}</h5>
                             </div>
                              <div class="vx-col lg:w-1/4 w-full">
                               <p style="color:#A8A8A8">{{$t('RegistrationDue')}}</p>
                               <h5  >{{ tr.RegistrationDateDue.split('T')[0]}}</h5>
                             </div>
                           </div>
                           <div class="vx-row lg:w-1/3 w-full ">
                                <vs-button color="#579ACB" style=" width:250px;height:40px" class="mr-5"  v-if="$acl.check('trainee')" @click="Registration(tr)">{{$t('Register')}}</vs-button>
                                 
                                <!-- <vs-button color="#579ACB" style=" width:300px;height:50px ;margin-top:5px" class="mr-5"  @click.stop="$router.push({path: '/Report/UpcomingCourseDetail/'+tr.ID})">Download Course Plan in pdf</vs-button> -->

                           </div>
                         </div>
                     </vx-card>
                   </div>
                   </div> 
            </div>
    </div>
</template>
<script>
import moduleCourse from "@/store/course/moduleCourse.js";


export default {
    data(){
        return{
            course_not_found:false,
            courseModel:{},
            summary:true
        }
    },
    methods:{
  Registration(annualPlan)
    {
         this.$router.push({name: 'ConfirmRegistration', params: { ID: annualPlan.ID}});
    },
    },
    computed:{

    },
    created(){
      if (!moduleCourse.isRegistered) {
      this.$store.registerModule("courseList", moduleCourse);
      moduleCourse.isRegistered = true;
    }

        const ID = this.$route.params.ID
          debugger
        if(ID!=undefined)
        {

            this.$store.dispatch("courseList/GetItemByID", ID)
            .then(res => {
                if(res instanceof Array)
                   this.courseModel = res[0].data;   
                else
                  this.courseModel = res.data;   
            })
            .catch(err => {
                    if(err.response.status === 404) {
                    this.course_not_found = true
                    return
                    }
                    console.error(err) 
                })
        }
    }
}
</script>


<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
  input[type="color" i]{
    height: 35px!important;
  }
  #colorPicer .vs-input--input.normal
  {
  padding: 0.2rem
  }
</style>
<style>
.vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large){
  padding: .75rem 1rem
}
</style>